//######################### Step Data #########################
export const stepStatus_NotSubmitted = 'not-submitted';
export const stepStatus_Submitting = 'submitting';
export const stepStatus_Submitted = 'submitted';
const stepStatuses = [stepStatus_NotSubmitted, stepStatus_Submitting, stepStatus_Submitted];
export const displayMode_Form = 'form';
export const displayMode_FreeText = 'free-text';
export const displayMode_Search = 'search';
const displayModes = [displayMode_Form, displayMode_FreeText, displayMode_Search];
//######################### Wizard Data #########################
export const advisorWizard_ContextType_Order = 'order';
export const advisorWizard_ContextType_Protocol = 'protocol';
const advisorWizard_ContextType = [advisorWizard_ContextType_Order, advisorWizard_ContextType_Protocol];
//# sourceMappingURL=types.js.map